// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__rJvAo","overlay":"Modal_overlay__3g0Vt","content":"Modal_content__TYS1V","opened":"Modal_opened__p4S-P","isClosing":"Modal_isClosing__kXUfg"};